import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import Icon from '../primitives/Icon.jsx';

/** The way back from a detail page to its section, named after the section. */
const BackLink = ({ to, children }) => {
  return (
    <Link className="comp-back-link" to={to}>
      <Icon icon={ArrowLeft} size="sm" />
      {children}
    </Link>
  );
};

export default BackLink;
